import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ background: '#161616', padding: '3.5rem 1.5rem 2rem' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '2.5rem',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        {/* Logo + Description */}
        <div>
          <img src={logo} alt="TurfX" style={{ height: '140px', objectFit: 'contain', marginBottom: '1rem', filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 1)) drop-shadow(0 0 16px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 24px rgba(255, 255, 255, 0.75))' }} />
          <p style={{ color: '#a0aec0', fontSize: '0.88rem', lineHeight: 1.7, maxWidth: '240px' }}>
            India's premier sports turf booking platform. Find, book, and play at premium venues near you.
          </p>
        </div>

        {/* Company */}
        <div>
          <h4 style={{ color: '#a0aec0', fontSize: '0.72rem', fontWeight: '700', letterSpacing: '2px', marginBottom: '1.5rem', textTransform: 'uppercase' }}>
            Company
          </h4>
          {[
            { label: 'About Us', to: '/about' },
            { label: 'Blogs', to: '/' },
            { label: 'Contact', to: '/contact' },
            { label: 'Partner with Us', to: '/partner' },
          ].map(item => (
            <div key={item.label} style={{ marginBottom: '12px' }}>
              <Link to={item.to} style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.88rem', fontWeight: '500', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#CEF17B'}
                onMouseLeave={e => e.target.style.color = '#a0aec0'}
              >{item.label}</Link>
            </div>
          ))}
        </div>

        {/* Social */}
        <div>
          <h4 style={{ color: '#a0aec0', fontSize: '0.72rem', fontWeight: '700', letterSpacing: '2px', marginBottom: '1.5rem', textTransform: 'uppercase' }}>
            Social
          </h4>
          {['Instagram', 'Facebook', 'LinkedIn', 'Twitter'].map(item => (
            <div key={item} style={{ marginBottom: '12px' }}>
              <Link to="/" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.88rem', fontWeight: '500', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#CEF17B'}
                onMouseLeave={e => e.target.style.color = '#a0aec0'}
              >{item}</Link>
            </div>
          ))}
        </div>

        {/* Legal */}
        <div>
          <h4 style={{ color: '#a0aec0', fontSize: '0.72rem', fontWeight: '700', letterSpacing: '2px', marginBottom: '1.5rem', textTransform: 'uppercase' }}>
            Privacy & Terms
          </h4>
          {[
            { label: 'Privacy Policy', path: '/privacy-policy' },
            { label: 'Terms & Conditions', path: '/terms-and-conditions' },
            { label: 'Customer Agreement', path: '/customer-agreement' },
            { label: 'Venue Partner Agreement', path: '/partner-agreement' },
            { label: 'Account Deletion', path: '/account-deletion' },
            { label: 'Contact Support', path: '/contact' },
          ].map(item => (
            <div key={item.label} style={{ marginBottom: '12px' }}>
              <Link to={item.path} style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.88rem', fontWeight: '500', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#CEF17B'}
                onMouseLeave={e => e.target.style.color = '#a0aec0'}
              >{item.label}</Link>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        marginTop: '3rem', paddingTop: '1.5rem',
        maxWidth: '1200px', margin: '3rem auto 0',
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: '1rem',
      }}>
        <p style={{ color: '#a0aec0', fontSize: '0.82rem' }}>
          © {year}  All Rights Reserved. Powered by{' '}
          <a href="https://metaqode.co.in" target="_blank" rel="noopener noreferrer" style={{ color: '#CEF17B', fontWeight: '600', textDecoration: 'none' }}>MetaQode Technologies Pvt. Ltd.</a>
        </p>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          {['Book', 'Play', 'Enjoy'].map(w => (
            <span key={w} style={{ color: '#a0aec0', fontSize: '0.82rem', fontWeight: '600' }}>{w}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}
